export default class LazyLoader {
    static get xlsx() {
        return import(/* webpackChunkName: "export", webpackMode: "lazy" */ 'xlsx');
    }
    static table() {
        return import(/* webpackChunkName: "table", webpackMode: "lazy" */ 'dash-table/dash/fragments/DataTable');
    }
}
